import { memo } from 'react';
import { NavDropdown } from 'react-bootstrap';

import { useTheme } from '@/hooks';

import styles from './ThemeSwitcher.module.scss';

export const ThemeSwitcher = memo(function ThemeSwitcher() {
  const { currentTheme, setTheme, availableThemes } = useTheme();

  const handleThemeChange = (themeId: string): void => {
    setTheme(themeId);
  };

  return (
    <NavDropdown
      title={
        <span className={styles.toggleContent}>
          <span
            className={styles.colorDot}
            style={{ backgroundColor: currentTheme.variables['--bs-primary'] }}
          />
          <span className={styles.themeName}>{currentTheme.name}</span>
        </span>
      }
      id="theme-dropdown"
      align="end"
      className={styles.dropdown}
    >
      {availableThemes.map((theme) => (
        <NavDropdown.Item
          key={theme.id}
          onClick={() => handleThemeChange(theme.id)}
          className={styles.themeOption}
          active={theme.id === currentTheme.id}
        >
          <span className={styles.colorPreview}>
            <span
              className={styles.accentDot}
              style={{
                backgroundColor: theme.variables['--bs-primary'],
              }}
            />
            <span
              className={styles.bgSquare}
              style={{ backgroundColor: theme.variables['--bs-body-bg'] }}
            />
            <span
              className={styles.secondarySquare}
              style={{ backgroundColor: theme.variables['--bs-secondary'] }}
            />
          </span>
          <span className={styles.themeInfo}>
            <span className={styles.themeTitle}>
              {theme.name}
              {theme.id === currentTheme.id && (
                <span className={styles.checkmark}>
                  <i className="bi bi-check2" />
                </span>
              )}
            </span>
            <span className={styles.themeDescription}>{theme.description}</span>
          </span>
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
});
